export default "__VITE_ASSET__DbIyO1fg__"